import React from 'react';
import { Selector } from '../../../components/Forms/Selector/Selector';
import { SelectorOption } from '../../../components/Forms/Selector/types';

const options: SelectorOption[] = [
  {
    label: 'Popularity',
    value: 'popularity',
  },
  {
    label: 'Start Date',
    value: 'startdate',
  },
];

export const SortBySelector = React.memo(
  ({
    values,
    onChange,
    mobileMode,
  }: {
    values: string[];
    onChange: (values: string[]) => void;
    mobileMode: boolean;
  }) => (
    <Selector
      label="Sort By"
      name="sort-by"
      options={options}
      values={values}
      onChange={onChange}
      mobileMode={mobileMode}
      dropDownOnLeft
    />
  )
);
